<app-bottom-sheet
	#sheet
	ariaLabel="جزئیات تراکنش کیف‌پول"
	bodyClass="-mx-4"
	footerClass="pt-2 pb-[calc(1.5rem+env(safe-area-inset-bottom))]"
	(closed)="closed.emit()">
	<ng-template #body>
		@if (request(); as request) {
			<div class="flex flex-col items-center gap-3 px-4 pb-4 text-center">
				<h2 class="w-full text-sm font-bold text-gray-900">{{ request.timeline.title }}</h2>

				<div class="relative flex w-full flex-col" data-cy="wallet-transfer-detail-timeline">
					@for (step of request.timeline.steps; track $index) {
						<div
							class="relative flex pb-6 items-start justify-start gap-2"
							[class.min-h-20]="!$last"
							[attr.data-cy]="'wallet-transfer-detail-step-' + $index">
							@if (!$last) {
								<span aria-hidden="true" [class]="stepLines[step.status]"></span>
							}

							<span [class]="stepCircles[step.status]">
								@if (step.status === 'done' || step.status === 'failed') {
									<ui-icon
										width="12"
										height="12"
										aria-hidden="true"
										[iconName]="step.status === 'failed' ? 'close' : 'check'" />
								}
							</span>

							<div class="flex min-w-0 flex-1 flex-col items-start gap-1.5">
								<div class="flex w-full items-center justify-between gap-2">
									<span dir="rtl" [class]="stepTitles[step.status]">{{ step.title }}</span>
									@if ($index === chipStepIndex()) {
										<ui-chip size="xs" [label]="request.stateLabel" [tip]="request.stateTip" />
									}
								</div>

								@if (step.dateLabel || step.amount !== null) {
									<span
										class="flex w-full justify-between gap-2 text-3.25 font-medium text-mofid-700"
										dir="rtl">
										@if (step.dateLabel) {
											<span class="w-full text-right text-xs text-gray-500" dir="ltr">{{
												step.dateLabel
											}}</span>
										}
										@if (step.amount !== null) {
											<span class="flex shrink-0 items-center gap-1">
												<ui-number format="1.0-0" dir="ltr" [value]="step.amount!" />
												<span>ریال</span>
											</span>
										}
									</span>
								}
							</div>
						</div>
					}
				</div>

				@if (request.notice; as notice) {
					<ui-alert
						class="w-full text-right"
						data-cy="wallet-transfer-detail-notice"
						variant="red"
						size="lg"
						[dismissible]="false"
						[title]="notice.title"
						[description]="notice.description" />
				}
			</div>
		}
	</ng-template>

	<ng-template #footer>
		<ui-button class="w-full" extraButtonClasses="w-full" variant="mute" size="lg" (clicked)="close()"
			>بستن</ui-button
		>
	</ng-template>
</app-bottom-sheet>
